import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useEntityStore } from '../../common/composables/entityStore';
import type { PackageType } from '../domain/packageType';

export const usePackageTypeStore = defineStore('package-types', () => {
  const { add, getById, clear, merge, remove, changed, getOrThrow, list } =
    useEntityStore<PackageType>({
      eventName: 'package-type-changed',
      getEntityId(entity) {
        return entity.id;
      },
      updateEntity(dest, src) {
        dest.name = src.name;
        dest.pieces = src.pieces;
        dest.layers = src.layers;
        dest.piecesPerLayer = src.piecesPerLayer;
        dest.spacerHeight = src.spacerHeight;
        dest.packagingIds = src.packagingIds;
      },
      hasChanged(existing, incoming) {
        return JSON.stringify(existing) !== JSON.stringify(incoming);
      },
    });

  return {
    changed,
    getById,
    add,
    remove,
    getOrThrow,
    merge,
    clear,
    packageTypes: computed(() => list.value),
    sortedByName: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
      return clone;
    }),
  };
});
